import { render, staticRenderFns } from "./PaymentMethodForm.vue?vue&type=template&id=1589b064&"
import script from "./PaymentMethodForm.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports